import { generateInteractionProps } from "@/utils/generate-smart-toilets-interactions"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const handleModalInteractions = (title, heading, isExpand = false) => {
  const interactionData = generateInteractionProps(
    `${title}:${isExpand ? "expand" : "close"}`,
    {
      internalLinkName: isExpand ? title : "close",
      internalLinkPosition: `pxp:${heading}`,
      internalLinkType: `pxp:${title}`,
      internalLinkZoneName: `pxp:shop smart toilets:${heading}`,
    }
  )

  pushAnalyticsObjToDataLayer({ ...interactionData })
}
